module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/138-bahrain-bd2b65215b61e4be9b55b2d9acbd0095.svg";